import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const QuotePostModal = ({ post, quoteContent, setQuoteContent, onSubmit, onClose }) => {
  if (!post) return null;
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
          onClick={e => e.stopPropagation()}
          className="bg-white rounded-2xl w-full max-w-lg p-6"
        >
          <h3 className="text-xl font-bold text-gray-900 mb-4">Quote Post</h3>
          <textarea
            value={quoteContent}
            onChange={e => setQuoteContent(e.target.value)}
            placeholder="Add your thoughts..."
            className="w-full bg-gray-50 border border-gray-200 rounded-xl p-4 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#4A90E2]/50 resize-none h-24 mb-4"
          />
          <div className="border border-gray-200 rounded-xl p-4 mb-4 bg-gray-50">
            <div className="flex items-center space-x-2 mb-2">
              <img src={post.avatar_url || 'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg'} alt={post.full_name} className="w-8 h-8 rounded-full object-cover" />
              <span className="font-medium text-sm">{post.full_name}</span>
              <span className="text-gray-500 text-sm">@{post.username}</span>
            </div>
            <p className="text-gray-700 text-sm line-clamp-3">{post.content}</p>
          </div>
          <div className="flex justify-end space-x-3">
            <button onClick={onClose} className="px-5 py-2.5 text-gray-600 hover:bg-gray-100 rounded-full transition-colors font-medium">Cancel</button>
            <button onClick={() => onSubmit(post.id)} className="px-5 py-2.5 bg-gradient-to-r from-[#4A90E2] to-[#A855F7] text-white rounded-full font-medium hover:opacity-90 transition-opacity">Quote</button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default QuotePostModal;
